import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Banner = ({ dynamicImages }) => {
    const bannerUrl = process.env.REACT_APP_Banner;
    
    const settings = {
        dots: true,
        infinite: true,
        speed: 100,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true, // Enable auto slide
        autoplaySpeed: 3500,
        fade: true
    };

    return (
        <>
            <Slider {...settings}>
                {dynamicImages.map((bannerdata, index) => (
                    <div key={index}>
                        <img src={bannerUrl + bannerdata.Image} alt={`Banner ${index + 1}`} className='bannerImage' />
                    </div>
                ))}
            </Slider>
        </>
    )
}
export default Banner